import React, { useEffect, useState } from "react";
import Controls from "src/components/form/controls/Controls";
import useForm, { Form } from "src/hooks/useForm";
import { isDisableSubmit } from "src/pages/DisplayManagement/utils";
import { validationReleaseTypeSpeakerInput } from "src/pages/VersionRelease/utils/validateInput";

const initialValue = {
  id: "",
  typeSpeaker: "",
  name: "",
};

function ReleaseTypeSpeakerForm(props) {
  const { addOrEdit, recordForEdit, errorsForm } = props;
  const [valueAddNew, setValueAddNew] = useState(initialValue);

  // validation input permission
  const validateFLFReleaseTypeSpeakerForm = (fieldValues = values) => {
    let temp = validationReleaseTypeSpeakerInput(fieldValues, { ...errors });

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialValue, true, validateFLFReleaseTypeSpeakerForm);

  const onSubmit = (e) => {
    e.preventDefault();
    if (validateFLFReleaseTypeSpeakerForm()) {
      addOrEdit(values, resetForm);
      setValueAddNew(initialValue);
    }
  };

  useEffect(() => {
    setErrors({
      ...errorsForm,
    });
  }, [errorsForm, setErrors]);

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues({
        ...recordForEdit,
      });
    } else {
      setValues({
        ...valueAddNew,
      });
      setErrors({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordForEdit]);

  const handleOnChange = (e) => {
    handleInputChange(e);

    if (!recordForEdit) {
      const { name, value, type } = e.target;
      setValueAddNew({
        ...valueAddNew,
        [name]: type === "number" ? +value : value,
      });
    }
  };

  return (
    <Form onSubmit={onSubmit}>
      <Controls.Input
        name="name"
        value={values.name}
        label="Name"
        type="text"
        onChange={handleOnChange}
        error={errors.name}
      />

      <Controls.Input
        name="typeSpeaker"
        value={values.typeSpeaker}
        label="typeSpeaker"
        type="text"
        onChange={handleOnChange}
        error={errors.typeSpeaker}
      />

      <Controls.Button
        sx={{ width: "100%", marginTop: "10px" }}
        type="submit"
        text="Submit"
        disabled={isDisableSubmit(recordForEdit, values)}
      />
    </Form>
  );
}

export default ReleaseTypeSpeakerForm;
